import moment from 'moment-timezone'
import Vue from 'vue'

/**
 * moment locale 設定
 */
moment.locale('ja')
moment.tz.setDefault('Asia/Tokyo')

/**
 * 日付をフォーマットする
 * @example {{ date | formatDate }}
 * @example {{ date | formatDate('YYYY/MM/DD') }}
 * @param date
 * @param format
 * @returns {any}
 */
export const formatDate = (date, format = 'YYYY/MM/DD') => (date ? moment(date).format(format) : null)

/**
 * 複数の日付を連結し、かつ月が同じ場合は省略してカンマ区切りで並べる。
 * @example {{ schedules | combineDates }}
 * @param dates
 * @param dateMonthFormat
 * @param dateFormat
 * @returns {string}
 */
export const combineDates = (dates, dateMonthFormat = 'M/D', dateFormat = 'D') => {
  const monthDates = []
  let lastMonth = null
  dates.forEach((date) => {
    const mom = moment(date)
    monthDates.push(mom.format('M') !== lastMonth ? mom.format(dateMonthFormat) : mom.format(dateFormat))
    lastMonth = mom.format('M')
  })
  return monthDates.join(',')
}

/**
 * 配列を改行区切りで返す
 * @example {{ values | arrayWrap }}
 * @param string
 * @returns {*}
 */
export const arrayWrap = string => (Array.isArray(string) ? string.join('\n') : string)

/**
 * _.map のラッパー
 * @param list
 * @param key
 * @returns {array}
 */
export const pluck = (list, key) => window._.map(list, key)

/**
 * 数字をフォマットする
 * Intl.NumberFormat API
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat
 * @param num
 * @returns number
 */
export const number = num => new Intl.NumberFormat('ja-JP').format(num)

/**
 * HTML タグを除去する
 * @param value
 * @returns string
 */
export const stripTags = value => {
  const div = document.createElement('div')
  div.innerHTML = value
  return div.textContent || div.innerText || ''
}

/**
 * 先頭からN文字分を切り出す
 */
export const heading = (value, width = 100) => {
  const headingString = value.substr(0, width)
  return headingString.length < value.length
    ? `${headingString}...`
    : headingString
}
/**
 *  add days to date
 * @param date
 * @param days
 * @returns {string|*}
 */
export const addDaysToDate = (date, days = 14) => {
  if (date) {
    return moment(date).add(days, 'days').format('YYYY-MM-DD HH:mm')
  }
  return date
}

/**
 * Vueのグローバルフィルタに登録する
 */
export const registerGlobalFilters = () => {
  Vue.filter('formatDate', formatDate)
  Vue.filter('combineDates', combineDates)
  Vue.filter('arrayWrap', arrayWrap)
  Vue.filter('pluck', pluck)
  Vue.filter('number', number)
  Vue.filter('stripTags', stripTags)
  Vue.filter('heading', heading)
  Vue.filter('addDaysToDate', addDaysToDate)
}
